const features = [
  {
    icon: 'ri-stack-line',
    title: '海量资源',
    desc: '2000+部热门漫画持续更新，韩漫日漫国漫全覆盖。无论是最新连载还是经典完结作品，妖精动漫网一站式满足你的阅读需求。',
    color: 'text-primary-500',
    bg: 'bg-primary-50',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速加载',
    desc: '采用智能预加载技术，翻页无等待，下拉式阅读如丝般顺滑。即使网络环境一般，也能享受流畅的漫画阅读体验。',
    color: 'text-accent-500',
    bg: 'bg-accent-50',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全端适配',
    desc: '手机、平板、电脑完美适配，响应式设计确保任何设备都能获得最佳阅读体验。躺在床上用手机追漫，坐在电脑前大屏享受。',
    color: 'text-secondary-500',
    bg: 'bg-secondary-50',
  },
  {
    icon: 'ri-image-line',
    title: '高清画质',
    desc: '原版高清扫描，画质清晰细腻，支持缩放查看细节。每一格画面都保持原作的精美质感，让漫画的视觉魅力不打折扣。',
    color: 'text-primary-500',
    bg: 'bg-primary-50',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            平台特色
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-[480px] mx-auto">
            妖精动漫用心打造每一处阅读细节
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((f, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 text-center group hover:border-accent-200 transition-colors duration-200"
            >
              <div className={`w-12 h-12 mx-auto flex items-center justify-center rounded-xl ${f.bg} mb-4`}>
                <i className={`${f.icon} text-xl ${f.color}`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-2">{f.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}